import { render, staticRenderFns } from "./test3.vue?vue&type=template&id=7ec32b91&scoped=true&"
import script from "./test3.vue?vue&type=script&lang=js&"
export * from "./test3.vue?vue&type=script&lang=js&"
import style0 from "./test3.vue?vue&type=style&index=0&id=7ec32b91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec32b91",
  null
  
)

export default component.exports